module.exports = __webpack_public_path__ + "assets/img/joker-g.1dab9774.png";